import {
    observable, computed, reaction, makeObservable, action, toJS,
} from 'mobx'
import * as R from 'ramda'

import { v4 as uuidv4 } from 'uuid'

const quadrantNames = {
    0: 'xAxis',
    1: 'yAxis',
    2: 'zAxis',
}

class NewWidgetMetric {
    @observable industry

    @observable respondentType

    @observable surveyType

    @observable productType

    @observable question

    @observable id

    @observable metricLabel

    constructor(
        metric = {},
        store,
        appStore,
        metricIndex,
    ) {
        const {
            industry,
            respondentType,
            surveyType,
            productType,
            question,
            questionId,
        } = metric
        makeObservable(this)
        this.industry = industry
        this.respondentType = respondentType
        this.surveyType = surveyType
        this.productType = productType
        this.question = question
        this.store = store
        this.appStore = appStore
        this.metricIndex = metricIndex
        this.questionId = questionId
        this.id = uuidv4()
    }

    @action
    changeNewWidgetMetricBulk = (changes) => {
        changes.forEach((c) => { this[c.field] = c.value })
    }

    toJson() {
        return toJS(this)
    }

    toStandardised(isQuadrantAnalysis = false) {
        const { langcode } = this.appStore
        const isKpi = R.pathOr(false, ['question', 'type'], this) === 'KPI'
        // defaultName makes child questions from same parent not get overwritten because they have the same parentId
        const defaultName = R.pathOr('', ['question', 'content', 'shortTitle', langcode, 'text'], this)
        const name = isQuadrantAnalysis
            ? quadrantNames[this.metricIndex]
            : (this.metricLabel || defaultName)
        return {
            industry: this.industry,
            respondentType: this.respondentType,
            surveyType: this.surveyType,
            productType: this.productType,
            parentQuestion: R.pathOr(undefined, ['question', 'parentId'], this),
            formId: R.pathOr(undefined, ['question', 'formId'], this),
            questionOptions: R.pathOr(undefined, ['question', 'optionSetY', 'options'], this),
            questionInitialLocale: R.pathOr('en_GB', ['question', 'metadata', 'initialLocale'], this),
            questionId: isKpi
                ? '00000000-0000-0000-0000-000000000000'
                : R.pathOr(undefined, ['question', 'value'], this),
            qlistParentId: R.pathOr(undefined, ['question', 'qlistParentId'], this),
            isNps: R.pathOr(false, ['question', 'settings', 'frontend', 'renderNPS'], this)
            || (R.pathOr(false, ['question', 'metadata', 'kpiType'], this) === 'NPS'),
            questionTypeCode: this.questionTypeCode,
            name,
            value: R.pathOr(undefined, ['question', 'value'], this),
            label: this.metricLabel,
            group: isQuadrantAnalysis ? this.group : undefined,
        }
    }
}

export default NewWidgetMetric
